module.exports = __webpack_public_path__ + "img/event6.7f47a190.png";